import { GzPolicyPanelAccordionTemplateWebComponent } from './component/GzPolicyPanelAccordionTemplateWebComponent';

export { GzPolicyPanelAccordionTemplateWebComponent };
